let _player;
let _callback = () => { };
let _error = () => { };

const loadPlayer = () => {
    return new Promise((resolve, reject) => {
        // create a div with id player and style display none
        const div = document.createElement("div");
        div.id = "oto-player";
        div.style.display = "none";
        document.body.appendChild(div);

        // load the iframe script
        window.onYouTubeIframeAPIReady = () => {
            _player = new window.YT.Player('oto-player', {
                height: '0',
                width: '0',
                events: {
                    'onReady': resolve,
                    'onStateChange': (e) => {
                        if (e.data === -1) {
                            _callback(e.target.videoTitle);
                        }
                    },
                    'onError': (e) => _error(e)
                }
            });
        };

        // load the iframe script
        let script = document.createElement("script");
        script.src = `https://www.youtube.com/iframe_api`;
        document.head.appendChild(script);
    });
}

export const getVideoIdFromUrl = (url) => {
    return url.match(/^.*(?:(?:youtu.be\/)|(?:v\/)|(?:\/u\/\w\/)|(?:embed\/)|(?:watch\?))\??v?=?([^#&?]*).*$/)?.[1];
}

export const getVideoTitleFromUrl = (url) => {
    return new Promise(async (resolve, reject) => {
        const videoId = getVideoIdFromUrl(url);

        if (videoId === undefined) {
            resolve();
        }

        _callback = (videoTitle) => {
            if (videoTitle === undefined || videoTitle.length === 0) {
                resolve();
            }
            else {
                resolve(videoTitle);
            }
        };

        _error = (error) => {
            resolve();
        };

        if (!window.YT?.loaded) {
            await loadPlayer();
        };

        _player.cueVideoById(videoId);
    });
}